import { usePermissionsContext } from '../context/PermissionContext';

/**
 * Hook لاستخدام الصلاحيات في المكونات
 * هذا الملف هو واجهة مبسطة للوصول إلى سياق الصلاحيات
 */
export const usePermissions = () => {
  return usePermissionsContext();
};